import { AccountType } from '@ndvr/portfolio-api';

/**
 * Account types that require owner birth year
 */
export const IRA_ACCOUNT_TYPES: AccountType[] = [
    AccountType.TRADITIONAL_IRA,
    AccountType.ROTH_IRA,
    AccountType.SEP_IRA,
    AccountType.TRADITIONAL_401K,
    AccountType.ROTH_401K,
];

export const requiresBirthYear = (accountType: AccountType | null | undefined): boolean => {
    return accountType ? IRA_ACCOUNT_TYPES.includes(accountType) : false;
};
